import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, Sort } from '@angular/material';
import { NgForm } from '@angular/forms';
import { request } from 'http';
import { ParComplaintsTasksService } from './../../services/par_complaints_tasks/par-complaints-tasks.service';
import { ComplaintsDropDownService } from './../../services/complaints_drop_down/complaints-drop-down.service';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { documentInformationList } from '../../model/document.model';
import { UploadService } from '../../services/upload/upload.service';
import * as momenttimezone from 'moment-timezone';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
declare let ga: any;
@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.css']
})
export class AddTaskComponent implements OnInit {
  selectedValue: string;
  complaintType = [];
  public errMsg: any;
  public typeErr: boolean = false;
  public typeErr1: boolean = false;
  public addNewComplaintTitle: boolean = true;
  minDate = new Date();
  public submitFormData: any;
  activeFlag: boolean = false;
  requests = [];
  documentInfo: documentInformationList = new documentInformationList();
  isFileChanged: boolean = false;
  readonly: boolean = true;
  signedUrl;
  matSpinner: boolean = false;
  uploadFlag: boolean = true;

  data = {
    ComplaintType: '',
    MasterVendorName: '',
    VendorLocation: '',
    DueDate: '',
    Date: new Date,
    Complainant: '',
    Email: '',
    Comment: '',
    Request: '',
    Amount: '',
    FileName: [],
    DocumentLink: [],
    ComplaintId: '',
    AttachDocument: false
  }
  ManageTypeErrMsg: string;
  ManageTypeErr: boolean;
  loginId: string;
  firstName;
  lastName;

  constructor(public dialogRef: MatDialogRef<AddTaskComponent>,
    public complaintsDropDown: ComplaintsDropDownService,
    private parComplaintsTasksService: ParComplaintsTasksService,
    @Inject(MAT_DIALOG_DATA) public complaintData: any,
    public agentLocationService: AgentlocationService,
    public ref: ChangeDetectorRef,
    public uploadService: UploadService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.getRequest();
    this.data.MasterVendorName = this.complaintData.complaintData.MasterVendorName;
    this.data.ComplaintType = this.complaintData.complaintData.ComplaintType;
    this.data.ComplaintId = this.complaintData.complaintData.ComplaintId;
    this.agentLocationService.locationDetsOfAgent(this.complaintData.complaintData.VendorLocationId, this.complaintData.complaintData.MasterVendorId).subscribe(res => {
      if (res) {
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].Address1 !== undefined && res.vendorLocationDetails[0].Address1 !== null)
          this.data.VendorLocation = res.vendorLocationDetails[0].Address1;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].Address2 !== undefined && res.vendorLocationDetails[0].Address2 !== null)
          this.data.VendorLocation = this.data.VendorLocation + " " + res.vendorLocationDetails[0].Address2;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].City !== undefined && res.vendorLocationDetails[0].City !== null)
          this.data.VendorLocation = this.data.VendorLocation + "," + res.vendorLocationDetails[0].City;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].State !== undefined && res.vendorLocationDetails[0].State !== null)
          this.data.VendorLocation = this.data.VendorLocation + "," + res.vendorLocationDetails[0].State;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].PostalCode !== undefined && res.vendorLocationDetails[0].PostalCode !== null)
          this.data.VendorLocation = this.data.VendorLocation + "-" + res.vendorLocationDetails[0].PostalCode;
      } else {
        this.data.VendorLocation = "";
      }
    }, err => {
      this.errMsg = "Service Error " + err;
      this.typeErr = true;
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getRequest() {
    this.requests = [];
    this.complaintsDropDown.getRequest().subscribe(res => {

      if (res !== undefined && res !== '') {
        if (res.Request_drop_down_values !== undefined && res.Request_drop_down_values.length > 0) {
          res.Request_drop_down_values.forEach(data => {
            this.requests.push(data);
          });
        } else {
          this.errMsg = "No Requests data found ";
          this.typeErr1 = true;
        }
      } else {
        this.errMsg = "No Requests data found ";
        this.typeErr1 = true;
      }
    }, err => {
      this.errMsg = "Requests Service " + err;
      this.typeErr = true;
    });
  }

  setFileData(docInfo) {
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.FileName = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    this.isFileChanged = true;
  }

  onFormSubmit(form: NgForm) {
    this.matSpinner = true;
    this.uploadFlag = false;
    const userEnteredData = form.value;
    this.data.FileName = [];
    this.data.DocumentLink = [];

    let today = new Date();
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
    var filePath = "Complaint/" + this.data.ComplaintId + "/TaskDocs/";
    for (var i=0; i < this.documentInfo.file.length; i++) {
      let fileNameWithoutExt = this.documentInfo.file[i].name.substring(0, this.documentInfo.file[i].name.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.file[i].name.substring(this.documentInfo.file[i].name.lastIndexOf('.') + 1,
                                                                this.documentInfo.file[i].name.length);
      let fileName = this.documentInfo.file[i].name;
      this.documentInfo.fileInput[i].append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      let newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": newFilePath1,
      }
      this.data.DocumentLink.push(newFilePath1);
      this.data.FileName.push(fileName);
      let file = this.documentInfo.file[i];
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(file, this.signedUrl).subscribe((obj) => {
        });
      }, error => {
        this.errMsg = "Requests Service " + error;
        this.typeErr = true;
      });
    }
    this.submit(userEnteredData);
  }

  submit(userEntData) {
    const setTime = new Date(userEntData.DueDate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var dueDate = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (dueDate.includes('-05:00')) {
      dueDate = dueDate.replace('19:59:59', '18:59:59');
    }
    this.submitFormData = {
      "complaint_id": this.complaintData.complaintData.ComplaintId,
      "ComplaintStatus":this.complaintData.complaintData.ComplaintStatus,
      "master_vendor_id": this.complaintData.complaintData.MasterVendorId,
      "master_vendor_name": this.complaintData.complaintData.MasterVendorName,
      "vendor_location_id": this.complaintData.complaintData.VendorLocationId,
      "complainant": userEntData.Complainant,
      "attach_document": userEntData.AttachDocument,
      "email": userEntData.Email,
      "request": userEntData.request,
      "start_date": this.data.Date,
      "due_date": dueDate,
      "amount": userEntData.Amount !== null ? userEntData.Amount : 0,
      "notes": userEntData.Comment,
      "document_link": this.data.DocumentLink,
      "document_name": this.data.FileName,
      "created_by": this.loginId
    }

    this.parComplaintsTasksService.addTaskService(this.submitFormData).subscribe(res => {
      ga('CompliantsTracker.send', 'event',this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[3],userEntData.Email, 1);
      // this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[3],userEntData.Email, 1);
      setTimeout(() => {
        this.matSpinner = false;
        this.parComplaintsTasksService.load.next('success');
        this.dialogRef.close();
      }, 3000);
    }, error => {
      this.ManageTypeErrMsg = 'Par Complaints Tasks Service' + ' ' + error;
      this.ManageTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/add-task/add-task.component.ts